import { ASPECT_RATIOS, aspectRatioOf } from './aspect-ratio';
export const FORMAT_PRESETS = {
    'youtube-16-9': {
        id: 'youtube-16-9',
        name: 'YouTube 16:9',
        aspectRatio: ASPECT_RATIOS['16:9'],
        defaultResolution: { width: 1920, height: 1080 },
        fps: 30,
        orientation: 'landscape',
        safeAreas: { titleSafe: 0.1, actionSafe: 0.05, subtitleSafe: 0.15, platformSafe: 0.05 },
        platform: 'youtube',
    },
    'youtube-short-9-16': {
        id: 'youtube-short-9-16',
        name: 'YouTube Shorts 9:16',
        aspectRatio: ASPECT_RATIOS['9:16'],
        defaultResolution: { width: 1080, height: 1920 },
        fps: 30,
        orientation: 'portrait',
        safeAreas: { titleSafe: 0.1, actionSafe: 0.05, subtitleSafe: 0.2, platformSafe: 0.12 },
        platform: 'youtube',
    },
    'instagram-reel-9-16': {
        id: 'instagram-reel-9-16',
        name: 'Instagram Reel 9:16',
        aspectRatio: ASPECT_RATIOS['9:16'],
        defaultResolution: { width: 1080, height: 1920 },
        fps: 30,
        orientation: 'portrait',
        safeAreas: { titleSafe: 0.1, actionSafe: 0.05, subtitleSafe: 0.2, platformSafe: 0.14 },
        platform: 'instagram',
    },
    'instagram-feed-4-5': {
        id: 'instagram-feed-4-5',
        name: 'Instagram Feed 4:5',
        aspectRatio: ASPECT_RATIOS['4:5'],
        defaultResolution: { width: 1080, height: 1350 },
        fps: 30,
        orientation: 'portrait',
        safeAreas: { titleSafe: 0.1, actionSafe: 0.05, subtitleSafe: 0.18, platformSafe: 0.12 },
        platform: 'instagram',
    },
    'square-1-1': {
        id: 'square-1-1',
        name: 'Square 1:1',
        aspectRatio: ASPECT_RATIOS['1:1'],
        defaultResolution: { width: 1080, height: 1080 },
        fps: 30,
        orientation: 'square',
        safeAreas: { titleSafe: 0.1, actionSafe: 0.05, subtitleSafe: 0.15, platformSafe: 0.1 },
        platform: 'instagram',
    },
    'cinema-2-39': {
        id: 'cinema-2-39',
        name: 'Cinema 2.39:1',
        aspectRatio: ASPECT_RATIOS['2.39:1'],
        defaultResolution: { width: 4096, height: 1716 },
        fps: 24,
        orientation: 'landscape',
        safeAreas: { titleSafe: 0.12, actionSafe: 0.05, subtitleSafe: 0.85, platformSafe: 0.05 },
    },
    'cinema-16-9': {
        id: 'cinema-16-9',
        name: 'Cinema 16:9',
        aspectRatio: ASPECT_RATIOS['16:9'],
        defaultResolution: { width: 3840, height: 2160 },
        fps: 24,
        orientation: 'landscape',
        safeAreas: { titleSafe: 0.1, actionSafe: 0.05, subtitleSafe: 0.15, platformSafe: 0.05 },
    },
    'classic-4-3': {
        id: 'classic-4-3',
        name: 'Classic 4:3',
        aspectRatio: ASPECT_RATIOS['4:3'],
        defaultResolution: { width: 2048, height: 1536 },
        fps: 24,
        orientation: 'landscape',
        safeAreas: { titleSafe: 0.1, actionSafe: 0.05, subtitleSafe: 0.15, platformSafe: 0.05 },
    },
    'ultrawide-21-9': {
        id: 'ultrawide-21-9',
        name: 'Ultrawide 21:9',
        aspectRatio: ASPECT_RATIOS['21:9'],
        defaultResolution: { width: 3440, height: 1440 },
        fps: 24,
        orientation: 'landscape',
        safeAreas: { titleSafe: 0.12, actionSafe: 0.05, subtitleSafe: 0.85, platformSafe: 0.05 },
    },
};
export function getFormatPreset(id) {
    return FORMAT_PRESETS[id];
}
export function getFormatPresetByAspect(width, height) {
    const ratio = aspectRatioOf(width, height);
    return Object.values(FORMAT_PRESETS).find((preset) => Math.abs(aspectRatioOf(preset.aspectRatio.width, preset.aspectRatio.height) - ratio) < 0.01);
}
export function createCustomFormat(options) {
    const width = options.width;
    const height = options.height;
    const ratio = aspectRatioOf(width, height);
    return {
        id: `custom-${width}x${height}`,
        name: options.name ?? `Custom ${width}×${height}`,
        aspectRatio: {
            width: ratio >= 1 ? ratio : 1,
            height: ratio >= 1 ? 1 : 1 / ratio,
            label: `${width}:${height}`,
        },
        defaultResolution: { width, height },
        fps: options.fps ?? 24,
        orientation: width > height ? 'landscape' : width < height ? 'portrait' : 'square',
        safeAreas: { titleSafe: 0.1, actionSafe: 0.05, subtitleSafe: 0.15, platformSafe: 0.05 },
    };
}
//# sourceMappingURL=format.js.map